import React from "react";

interface SecondaryButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
  isFull?: boolean;
  disabled?: boolean;
  className?: string;  
  icon?: React.ReactNode;
  lableClassName?: string;
}

const PrimaryButtonButton: React.FC<SecondaryButtonProps> = ({
  onClick,
  label = "Submit",
  isFull = false,
  disabled,
  className,
  lableClassName,
  icon,
}) => {
  const labelClassName = 'text-[#005D6E] text-[12px] leading-[29px] uppercase font-bold rounded-[46px]  border-[#005D6E]' 
  const buttonClassName = `
    ${disabled ? "bg-gray-400 border-gray-400 cursor-not-allowed" : "bg-white text-[#75A7AD]  rounded-[46px]  border-[#005D6E] cursor-pointer"}
    rounded-[46px] flex items-center justify-center px-4  h-8 gap-2
    ${className || ""}
  `;

  return (
    <button 
      disabled={disabled}
      onClick={(e) => !disabled && onClick && onClick(e)}  
      className={buttonClassName}
    >
      {icon && <span className="text-white">{icon}</span>}
      <span className={labelClassName}>
        {label}
      </span>
    </button>
  );
};

export default PrimaryButtonButton;


// import React from "react";

// interface PrimaryButtonProps {
//   onClick?: () => void;
//   label?: string;
//   className?: string;
// }

// const PrimaryButton: React.FC<PrimaryButtonProps> = ({
//   onClick,
//   label = "Submit",
//   className,
// }) => {
//   return (
//     <button
//       onClick={onClick}
//       className={`w-fit px-4 py-2 h-[35px] bg-white rounded-[46px] opacity-100 flex items-center justify-center cursor-pointer 
//                   sm:px-6 sm:py-2 sm:h-[40px] 
//                   md:px-8 md:py-2 md:h-[45px] 
//                   ${className}`}>
//       <span
//         className="text-[14px] leading-[24px] font font-bold text-[#75A7AD] 
//                       sm:text-[16px] sm:leading-[29px]">
//         {label}
//       </span>
//     </button>
//   );
// };

// export default PrimaryButton;
